import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { cn } from "@/lib/utils";

interface RadioGroupProps
  extends Omit<React.ComponentProps<typeof RadioGroupPrimitive.Root>, "onChange"> {
  onChange?: (value: string) => void;
}

function RadioGroup({ className, onChange, ...props }: RadioGroupProps) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("flex gap-4", className)}
      {...props}
      onValueChange={onChange}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        "border-input text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square shrink-0 cursor-pointer transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        "border-primary bg-paper box-border inline-block size-8 rounded border-3",
        // ::after
        "after:border-paper data-[state=checked]:after:bg-primary hover:data-[state=unchecked]:after:bg-primary-light after:box-border after:block after:size-full after:rounded after:border-3 after:transition-colors",
        className,
      )}
      {...props}
    >
      {/*<RadioGroupPrimitive.Indicator className="block size-full">
        <span className="border-paper bg-primary block size-full rounded border-3" />
      </RadioGroupPrimitive.Indicator>*/}
    </RadioGroupPrimitive.Item>
  );
}

interface RadioGroupItemWithLabelProps
  extends React.ComponentProps<typeof RadioGroupPrimitive.Item> {
  label: string;
}

function RadioGroupItemWithLabel({ label, ...props }: RadioGroupItemWithLabelProps) {
  return (
    <label htmlFor={props.id} className="flex w-max max-w-full cursor-pointer items-center gap-2">
      <RadioGroupItem {...props} />
      <span>{label}</span>
    </label>
  );
}

export { RadioGroup, RadioGroupItem, RadioGroupItemWithLabel };
